export default function messageFromError(error)
{
    try
    {
        const errorMessage = error.response.data.error?.message;
        return errorMessage ? errorMessage : "An error occurred"
    }
    catch {
        return "An error occurred"
    }
}